import React from 'react';
import { Col, Row } from 'antd';

export default function FluxoCaixaMensalAnalitico({valoresProvisionados}) {

    return (
        <div>
            {!valoresProvisionados &&
                <div className="tabela-fluxo">
                    <Row className="b-color-secondary col-layout c-black">
                        <Col align="left" span={6}><b>CONTA GERENCIAL</b></Col>
                        <Col align="center" span={3}><b>OUTUBRO/2020</b></Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col align="right" span={6}><b>SALDO INICIAL</b></Col>
                            <Col align="right" span={3}>26.477,56</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={6}>Clientes - Revenda de Mercadoria</Col>
                            <Col align="right" span={3}>0,00</Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col align="right" span={6}><b>TOTAL DE ENTRADAS</b></Col>
                            <Col align="right" span={3}>26.477,56</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={6}>Compras de Mercadorias para Revenda</Col>
                            <Col align="right" span={3}>0,00</Col>
                        </Row>
                        <Row className="c-red row">
                            <Col align="right" span={6}><b>TOTAL DE SAÍDAS</b></Col>
                            <Col align="right" span={3}>26.477,56</Col>
                        </Row>
                        <Row className="row">
                            <Col align="right" span={6}><b>SALDO FINAL</b></Col>
                            <Col align="right" span={3}>26.477,56</Col>
                        </Row>  
                    </div>
                </div>
            }
            {valoresProvisionados &&
                <div className="tabela-fluxo">
                    <Row className="b-color-secondary col-layout c-black t-head">
                        <Col align="left" span={6}><b>CONTA GERENCIAL</b></Col>
                        <Col align="center" span={3}>
                            <Row>
                                <Col span={24} align="center"><b>OUTUBRO/2020</b></Col>
                            </Row>
                            <Row>
                                <Col span={12} align="center"><b>PREVISTO</b></Col>
                                <Col span={12} align="center"><b>REALIZADO</b></Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col align="right" className="col" span={6}><b>SALDO INICIAL</b></Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">26.477,56</Col>
                                    <Col span={12} align="right">26.477,56</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={6}>Clientes - Revenda de Mercadoria</Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">0,00</Col>
                                    <Col span={12} align="right">0,00</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col align="right" span={6}><b>TOTAL DE ENTRADAS</b></Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">26.477,56</Col>
                                    <Col span={12} align="right">26.477,56</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={6}>Compras de Mercadorias para Revenda</Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">0,00</Col>
                                    <Col span={12} align="right">0,00</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="c-red row">
                            <Col align="right" span={6}><b>TOTAL DE SAÍDAS</b></Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">26.477,56</Col>
                                    <Col span={12} align="right">26.477,56</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="row">
                            <Col align="right" span={6}><b>SALDO FINAL</b></Col>
                            <Col className="col" align="right" span={3}>
                                <Row>
                                    <Col span={12} align="right">26.477,56</Col>
                                    <Col span={12} align="right">26.477,56</Col>
                                </Row>
                            </Col>
                        </Row>  
                    </div>
                </div>
            }
        </div>
    );
}